<script lang="ts">
    import { onMount } from "svelte";
    import { linear } from "svelte/easing";
    import { Tween } from "svelte/motion";

    const { user, mark } = $props<{ user: any, mark?: boolean }>();

    const size = 75;
    const pos = $state({
        top: Math.abs(randomNumber(window.innerHeight - size)) + "px",
        left: Math.abs(randomNumber(window.innerWidth - size)) + "px",
        width: size + "px",
        height: size + "px"
    });
    let color = $state('lime');
    const posStyle = $derived(Object.entries(pos).map(([key, value]) => `${key}: ${value}`).join(";"));
    let dirX = randomNumber(50, 20);
    let dirY = randomNumber(50, 20);
    let element: HTMLDivElement;

    const a = new Tween({
        x: 0,
        y: 0,
        rotation: 0,
        scale: 1
    }, { duration: 2000, easing: linear });

    function animate() {
        const elemPos = element?.getBoundingClientRect();
        if (elemPos) {
            if (elemPos.x <= -elemPos.width) {
                a.set({
                    ...a.current,
                    x: 0
                }, { duration: 0 });
                pos.left = window.innerWidth + 'px';
            }
            if (elemPos.x >= window.innerWidth) {
                a.set({
                    ...a.current,
                    x: 0
                }, { duration: 0 });
                pos.left = -elemPos.width + 'px';
            }

            if (elemPos.y <= -elemPos.height) {
                a.set({
                    ...a.current,
                    y: 0
                }, { duration: 0 });
                pos.top = window.innerHeight + 'px';
            }
            if (elemPos.y >= window.innerHeight) {
                a.set({
                    ...a.current,
                    y: 0
                }, { duration: 0 });
                pos.top = -elemPos.height + 'px';
            }
        }

        if (randomNumber(100) > 50) {
            dirX += randomNumber(10);
            dirY += randomNumber(10);
        }
        a.set({
            x: a.current.x + dirX,
            y: a.current.y + dirY,
            rotation: randomNumber(40),
            scale: (Math.random() * 0.8) + 0.5
        })

        setTimeout(animate, 2000);
    }

    function randomNumber(max: number, min: number = 0) {
        const sign = Math.random() < 0.5 ? -1 : 1;
        const number = Math.floor(Math.random() * (max - min + 1) + min);
        return number * sign;
    }

    onMount(() => {
        animate();
        setTimeout(() => {
            color = mark ? 'rose' : 'indigo';
        }, 5000);
    });
</script>

<div bind:this={element} 
    class="glow bg-radial from-indigo-950 to-indigo-700 border-1 border-gray-600 overflow-hidden absolute rounded-full flex items-center justify-center" 
    style="{posStyle}; transform: translate({a.current.x}px, {a.current.y}px) rotate({a.current.rotation}deg) scale({a.current.scale}); --user-glow-color:var(--color-{color}-500);">
    <span class="text-3xl">{user.initials}</span>
</div>

<style>
    .glow {
        animation: glow 1s ease-in-out infinite alternate;
    }

    @keyframes glow {
        from {
            box-shadow: 0 0 15px 2px var(--user-glow-color);
        }
        to {
            box-shadow: 0 0 15px 5px var(--user-glow-color);
        }
    }
</style>